
import { _Label } from '@common-models/label';
import { DBLabelThunks, waContactsCacheSelectors } from "@common-reducers/DBServiceThunks";
import { selectUser } from '@common-reducers/UserSelectors';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { getInboxCount, getUnreadContactIds, selectVisibleDedupedLabels } from '@common-reducers/labels-reducer/selectors';
import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode, useState } from 'react';
import classes from './label-top-header.module.scss';
import { overrideStyles } from './override-wa-styles';
import TopHeaderLabelItem from './top-header-label-item';





export default function LabelTopHeader() {

  overrideStyles()
  const activeLabelId = useAppSelector((state) => state.LabelReducer.activeLabelId)
  const user = useAppSelector(selectUser);
  const userIsLoggedIn = !!user?._id;
  const whatsApploadingScreen = document.querySelector("[data-testid='wa-web-loading-screen']")
  const labelsLoaded = useAppSelector((state) => state.DBLabelReducer.itemsLoaded);
  const inboxCount = useAppSelector(state => getInboxCount(state))
  const unreadContactIds = useAppSelector(state => getUnreadContactIds(state))
  const unreadCount = unreadContactIds.length
  
  // Visible + de-duplicated + order-sorted labels, memoized in the store (reactive
  // on label changes). Dedupe lives in the selector, not here — see #164.
  const dedupedLabels = useAppSelector(selectVisibleDedupedLabels)


  const waContacts = useAppSelector(state => waContactsCacheSelectors.selectAll(state))







  const labels = userIsLoggedIn ? dedupedLabels : []
  if (whatsApploadingScreen?.children) return

  return (
    <div
    data-bt-feature="labelFilterRow"
    onWheel={(e) => {
      e.currentTarget.scrollLeft += e.deltaY;
    }}
    className="flex items-center overflow-x-auto whitespace-nowrap flex-1 min-w-0 [&::-webkit-scrollbar]:hidden [scrollbar-width:none]">
      {labelsLoaded && labels.map((label, index) => (
        <TopHeaderLabelItem key={label?._id ?? index} label={label}
          inboxCount={inboxCount}
          unreadCount={unreadCount}
          isActive={!userIsLoggedIn ? label?.name === 'all' : label?._id === activeLabelId} />
      ))}
    </div>
  )
}








